/**
 * Client-side utility for adding joint checking parameters to enrollment URLs.
 * Mirrors the referral pattern in referralHelpers.ts.
 */

import { getCookie } from 'cookies-next';
import { JOINT_CHECKING_TOKEN_COOKIE } from './cookies';

const JOINT_CHECKING_PAGE_REGEX = /^\/joint-checking\/([^/]+)/;

export function isJointCheckingPage(path: string): boolean {
  return JOINT_CHECKING_PAGE_REGEX.test(path);
}

function getJointCheckingToken(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  // First check if we're on a joint-checking page - extract from URL
  const path = window.location.pathname;
  const match = path.match(JOINT_CHECKING_PAGE_REGEX);
  if (match?.[1]) {
    return match[1];
  }

  // Otherwise, check the cookie
  const cookieValue = getCookie(JOINT_CHECKING_TOKEN_COOKIE);
  if (cookieValue) {
    return cookieValue as string;
  }

  // Finally check URL params
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get('joint_account_token');
  if (token) {
    return token;
  }

  return null;
}

export function addJointCheckingParamsToUrl(url: string): string {
  if (!url.includes('/enroll')) {
    return url;
  }

  const token = getJointCheckingToken();
  if (!token) {
    return url;
  }

  try {
    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set('ad', 'ch_joint_account');
    urlObj.searchParams.set('joint_account_token', token);

    if (url.startsWith('/')) {
      return urlObj.pathname + urlObj.search;
    }
    return urlObj.toString();
  } catch {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}ad=ch_joint_account&joint_account_token=${token}`;
  }
}
